import gql from 'graphql-tag';
import { toastr } from 'react-redux-toastr';

export default function reorderMenus(menus) {
    return async (dispatch, getState, { client }) => {
        try {
            const mutation = gql`
                mutation reorderMenus($menus: [MenuOrderInput!]!) {
                    reorderMenus(menus: $menus) {
                        status
                        errorMessage
                    }
                }
            `;

            const { data } = await client.mutate({
                mutation,
                variables: { menus },
            });

            if (!data || !data.reorderMenus || data.reorderMenus.status !== 200) {
                const errorMessage =
                    (data && data.reorderMenus && data.reorderMenus.errorMessage) ||
                    'Failed to save menu order. Please try again.';
                toastr.error('Error!', errorMessage);
            }
        } catch (err) {
            toastr.error('Error!', String(err));
        }
    };
}
